import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import StatusReportContextProvider from './statusReportContext'

const DEFAULT_ALL_ITEMS_LABEL = 'All Tasks'

function StatusReportProvider ({ children, config, variant, templateId, templatePurposeKey, readOnly, disableCommenting }) {
  const configWithDefaults = useMemo(
    () => ({
      ...config,
      allItemsLabel: config?.allItemsLabel ?? DEFAULT_ALL_ITEMS_LABEL
    }),
    [config]
  )

  return (
    <StatusReportContextProvider
      config={configWithDefaults}
      variant={variant}
      templateId={templateId}
      templatePurposeKey={templatePurposeKey}
      readOnly={readOnly}
      disableCommenting={disableCommenting}
    >
      {children}
    </StatusReportContextProvider>
  )
}

StatusReportProvider.propTypes = {
  children: PropTypes.node,
  config: PropTypes.shape({
    filtersAt: PropTypes.arrayOf(PropTypes.number),
    allItemsLabel: PropTypes.string
  }),
  variant: PropTypes.oneOf(['default', 'board']),
  templateId: PropTypes.number,
  templatePurposeKey: PropTypes.string,
  readOnly: PropTypes.bool,
  disableCommenting: PropTypes.bool
}

StatusReportProvider.defaultProps = {
  variant: 'default',
  readOnly: false,
  disableCommenting: false
}

export default StatusReportProvider
